import cn from 'classnames';
import styles from './CheckboxField.module.scss';
import { ChangeEvent, ReactNode } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Checkbox } from '../Checkbox';

type CheckboxFieldProps = {
  label: ReactNode;
  name: string;
  required?: boolean;
  className?: string;
  onChange?: () => void;
  defaultValue?: boolean;
};

export function CheckboxField({
  label,
  name,
  required = false,
  className,
  onChange,
  defaultValue = false,
}: CheckboxFieldProps) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name,
    rules: {
      required: { value: required, message: 'required' },
    },
    defaultValue,
    control,
  });

  const error = fieldState.error ? fieldState.error.message : '';
  const wrapperClassName = cn(styles.wrapper, className);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    field.onChange(event);
    onChange?.();
  };

  return (
    <div className={wrapperClassName}>
      <label className={styles.label}>
        <Checkbox checked={field.value} onChange={handleChange} />
        {label}
      </label>
      {error && (
        <p className={styles.error}>
          {error === 'required' ? '*обязательное поле' : error}
        </p>
      )}
    </div>
  );
}
